import React from 'react';
import { useIsMobile } from '../hooks/useIsMobile';
import { useI18n } from '../i18n';
import '../styles/common.css';
import '../styles/ProductsPage.css';

const ProductsPage: React.FC = () => {
  const { t } = useI18n();
  const isMobile = useIsMobile();
  // 技术对比表数据
  const comparisonData = [
    {
      key: '1',
      feature: t('products.comparison.features.safety'),
      traditionalPositive: t('products.comparison.levels.low'),
      traditionalNegative: t('products.comparison.levels.medium'),
      nasopureliefa: t('products.comparison.levels.high')
    },
    {
      key: '2',
      feature: t('products.comparison.features.comfort'),
      traditionalPositive: t('products.comparison.levels.low'),
      traditionalNegative: t('products.comparison.levels.medium'),
      nasopureliefa: t('products.comparison.levels.high')
    },
    {
      key: '3',
      feature: t('products.comparison.features.effectiveness'),
      traditionalPositive: t('products.comparison.levels.low'),
      traditionalNegative: t('products.comparison.levels.medium'),
      nasopureliefa: t('products.comparison.levels.high')
    },
    {
      key: '4',
      feature: t('products.comparison.features.price'),
      traditionalPositive: t('products.comparison.levels.low'),
      traditionalNegative: t('products.comparison.levels.high'),
      nasopureliefa: t('products.comparison.levels.medium')
    }
  ];

  // 技术对比表列定义
  const columns = [
    {
      title: t('products.comparison.columns.feature'),
      dataIndex: 'feature',
      key: 'feature',
      className: 'text-center',
      width: '25%',
      ellipsis: true
    },
    {
      title: t('products.comparison.columns.traditionalPositive'),
      dataIndex: 'traditionalPositive',
      key: 'traditionalPositive',
      className: 'text-center',
      width: '25%',
      ellipsis: true
    },
    {
      title: t('products.comparison.columns.traditionalNegative'),
      dataIndex: 'traditionalNegative',
      key: 'traditionalNegative',
      className: 'text-center',
      width: '25%',
      ellipsis: true
    },
    {
      title: t('products.comparison.columns.nasopureliefa'),
      dataIndex: 'nasopureliefa',
      key: 'nasopureliefa',
      className: 'text-center table-success',
      width: '25%',
      ellipsis: true
    }
  ];

  // 产品图片轮播
  const productImages = [
    { src: '/img/IMG_2025.JPG', alt: t('products.images.product.design') },
    { src: '/img/IMG_1988.JPG', alt: t('products.images.product.detail') },
    { src: '/img/IMG_2011.JPG', alt: t('products.images.product.usage') },
    { src: '/img/IMG_1973.JPG', alt: t('products.images.product.showcase') }
  ];

  // 客户评价图片
  const customerImages = [
    { src: '/img/comment1.png', alt: t('products.images.testimonials.comment1') },
    { src: '/img/comment2.png', alt: t('products.images.testimonials.comment2') },
    { src: '/img/comment3.png', alt: t('products.images.testimonials.comment3') },
    { src: '/img/comment4.png', alt: t('products.images.testimonials.comment4') }
  ];

  return (
    <div className="products-page no-nav-offset">
      <section className="py-5" style={{ width: '100%', lineHeight: 0 }}>
        <img src={'/img/phone/29.jpg'} style={{ width: '100%' }} alt="spacing" className="img-fluid" />
      </section>
      <div className="hero-video-container" style={{ textAlign: 'center', padding: '1.5rem', backgroundColor: "#dbf0f5" }}>
        <video
          controls
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/img/video-poster.jpg"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            borderRadius: '15px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            display: 'block',
            backgroundColor: '#f0f0f0'
          }}
          onError={(e) => {
            console.log('视频加载失败:', e);
          }}
          onLoadStart={() => {
            // 确保视频静音
            const video = document.querySelector('.hero-video') as HTMLVideoElement;
            if (video) {
              video.muted = true;
              video.volume = 0;
              video.setAttribute('muted', 'true');
            }
          }}
          onCanPlay={() => {
            // 视频可以播放时强制静音
            const video = document.querySelector('.hero-video') as HTMLVideoElement;
            if (video) {
              video.muted = true;
              video.volume = 0;
              video.setAttribute('muted', 'true');
              // 尝试自动播放
              video.play().catch(e => {
                console.log('自动播放被阻止:', e);
              });
            }
          }}
        >
          <source src="/img/show.mp4" type="video/mp4" />
          <div className="video-fallback">
            <div className="video-icon">📹</div>
            <p className="video-text">{t('home.video.text')}</p>
            <small className="video-note">{t('home.video.note')}</small>
          </div>
        </video>
      </div>

      <section className="py-5" style={{ width: '100%' }}>
        <img src={'/img/phone/30.jpg'} style={{ width: '100%' }} alt="spacing" className="img-fluid" />
      </section>



    </div >
  );
};

export default ProductsPage;
